<template>
  <div class="jack">
    <img src="@/assets/promo/jack_promo.png" alt="Jacket Jack" class="promo">
    <a href="https://www.amazon.com/Created-By-Intelligent-Design-Jacket/dp/B00ABOLAMC/ref=sr_1_5?dchild=1&qid=1598738759&refinements=p_4%3ACreated+By+Intelligent+Design&s=mobile-apps&search-type=ss&sr=1-5">
      <img src="@/assets/buttons/amazon-kindlefire-white_badge.png" alt="">
    </a>
    <br><br>
    <h2>Save Jacket Jack!</h2>
    <br>
    <p class="app-blurb">Jack's been locked away in a padded cell for his own good. Will you save him from himself,
      or from the psychobabble prison keeping him captive?</p>
    <p class="app-blurb">The choice is yours.</p>
    <br><br>
    <iframe
      src="https://www.youtube.com/embed/MKFX1_8Sp-I"
      frameborder="0"
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
      :style="embedHeight"></iframe>
    <img src="@/assets/screenshots/jack_01.png" alt="">
    <img src="@/assets/screenshots/jack_02.png" alt="">
    <img src="@/assets/screenshots/jack_03.png" alt="">
  </div>
</template>

<script>
export default {
  name: 'Jack',
  computed: {
    factor () {
      return window.innerWidth / 1280
    },
    embedHeight () {
      return {
        height: 566 * this.factor + 'px'
      }
    }
  }
}
</script>

<style scoped>
.jack {
  background-color: cornflowerblue;
  color: white;
  font-weight: 800;
  font-size: 1.2em;
}
.jack img {
  margin: 0 10px;
}
.promo {
  margin: 0 !important;
  width: 100%;
}

h2 {
  width: 80%;
  margin: auto;
}
iframe {
  width: 100%;
}
</style>
